import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name: "Microbial Ecology of Food Systems", icon: icon1  },
  { name: "Microbiome Sequencing & Metagenomics for Food Research", icon:  icon2},
  { name: "Host–Microbe Interactions Influenced by Diet", icon:  icon3 },
  { name: "Metabolites, Enzymes & Nutrient Transformations", icon: icon4 },
  { name: "Microbial Dynamics in Food Safety", icon:   icon5},
  { name: "Microbiome-Based Strategies for Food Spoilage Control", icon :icon6 },
  { name: "Biopreservation-Microbes & Natural Antimicrobials", icon:  icon7 },
  { name: "Microbial Ecology of Food Systems - From Farm to Fork", icon:icon8 },
  { name: "Gut–Food Axis", icon:icon9},
  { name: "Personalized Nutrition", icon:icon10},
  { name: "Soil & Plant Microbiomes", icon:icon11 },
  { name: "Sustainable Agriculture & Food Production", icon: icon12 },
  { name: "Processing Technologies on Food Microbial Communities", icon:icon13 },
  { name: "Circular Bioeconomy & Waste Valorization", icon: icon14},
  { name: "Foodborne Microbial Risks", icon:icon15 },
  { name: "Prebiotics, Synbiotics & Postbiotics", icon:icon16 },
  { name: "Fermented Foods - Health Benefits & Innovation", icon: icon17 },
  { name: "Ethical & Commercial Considerations in Microbiome", icon: icon18 },
   { name: "Microbiome Engineering", icon: icon19 },
  { name: "Quorum Sensing", icon: icon20 },

];
